import React from "react"
import { Marker, useApiIsLoaded, useMap } from "@vis.gl/react-google-maps"
import { useTheme } from "@chakra-ui/react"
import GMap from "../gmaps/GMap"
import { BikeEntity } from "../lib/types/bike"
import { BIKE_MARKER_COLORS } from "../lib/static/bike"
import { useGoogleMapsEffect } from "../lib/hooks/useGoogleMapsEffect"
import { Coord, createBbox } from "../lib/helpers/map"
import { createGoogleMapBoundsFromBBox } from "../lib/helpers/googleMap"

interface LiveChaseGoogleMapsProps {
  bike: BikeEntity | undefined
}

const MAP_ID = "livechase-gmap"

const LiveChaseGoogleMaps: React.FC<LiveChaseGoogleMapsProps> = ({ bike }) => {
  const theme = useTheme()
  const map = useMap(MAP_ID)
  const apiIsLoaded = useApiIsLoaded()

  useGoogleMapsEffect(
    MAP_ID,
    () => {
      if (bike?.longitude && bike?.latitude && apiIsLoaded) {
        const coords: Coord[] = [[bike.longitude, bike.latitude]]
        const bbox = createBbox(coords)
        const bounds = createGoogleMapBoundsFromBBox(bbox)
        map?.fitBounds(bounds)
      }
    },
    [bike, apiIsLoaded],
  )

  const color = bike ? theme.colors[BIKE_MARKER_COLORS[bike.state]]["400"] ?? "#4299e1" : "#4299e1"

  const svgMarkerBike = {
    path: "m 18.359505,9.0008839 c 1.055844,0 1.919717,-0.8638727 1.919717,-1.9197171 0,-1.0558444 -0.863873,-1.9197171 -1.919717,-1.9197171 -1.055845,0 -1.919717,0.8638727 -1.919717,1.9197171 0,1.0558444 0.863872,1.9197171 1.919717,1.9197171 z M 8.2809898,15.239964 c -2.687604,0 -4.7992928,2.111689 -4.7992928,4.799293 0,2.687604 2.1116888,4.799293 4.7992928,4.799293 2.6876042,0 4.7992932,-2.111689 4.7992932,-4.799293 0,-2.687604 -2.111689,-4.799293 -4.7992932,-4.799293 z m 0,8.158798 c -1.8237313,0 -3.359505,-1.535774 -3.359505,-3.359505 0,-1.823731 1.5357737,-3.359505 3.359505,-3.359505 1.8237312,0 3.3595052,1.535774 3.3595052,3.359505 0,1.823731 -1.535774,3.359505 -3.3595052,3.359505 z m 5.5671802,-9.598586 2.30366,-2.30366 0.767887,0.767887 c 1.247816,1.247816 2.879576,2.015703 4.895279,2.015703 v -1.919717 c -1.439788,0 -2.591618,-0.575916 -3.455491,-1.439788 L 16.535774,9.0968698 C 16.055844,8.7129264 15.575915,8.5209547 15,8.5209547 c -0.575915,0 -1.055845,0.1919717 -1.343802,0.5759151 l -2.687604,2.6876032 c -0.383944,0.383944 -0.575915,0.863873 -0.575915,1.343802 0,0.575916 0.191971,1.055845 0.575915,1.343802 l 3.071547,2.687604 v 4.799293 h 1.919717 v -5.951123 z m 7.87084,1.439788 c -2.687604,0 -4.799293,2.111689 -4.799293,4.799293 0,2.687604 2.111689,4.799293 4.799293,4.799293 2.687604,0 4.799293,-2.111689 4.799293,-4.799293 0,-2.687604 -2.111689,-4.799293 -4.799293,-4.799293 z m 0,8.158798 c -1.823731,0 -3.359505,-1.535774 -3.359505,-3.359505 0,-1.823731 1.535774,-3.359505 3.359505,-3.359505 1.823731,0 3.359505,1.535774 3.359505,3.359505 0,1.823731 -1.535774,3.359505 -3.359505,3.359505 z",
    fillColor: "#fff",
    fillOpacity: 1,
    strokeWeight: 0,
  }

  const svgMarkerCircle = {
    path: "M-5,15a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
    fillColor: color,
    fillOpacity: 1,
    strokeWeight: 0,
  }

  return (
    <GMap mapId={MAP_ID} zoomControl={false} containerStyle={{ height: `50vh`, width: `100%` }}>
      {bike && (
        <>
          <Marker
            position={{
              lng: bike.longitude!,
              lat: bike.latitude!,
            }}
            icon={svgMarkerCircle}
          />
          <Marker
            position={{
              lng: bike.longitude!,
              lat: bike.latitude!,
            }}
            icon={svgMarkerBike}
          />
        </>
      )}
    </GMap>
  )
}

export default LiveChaseGoogleMaps
